// 常量
export const EXPIRE_TIME = 60 * 60 * 1000 * 24 * 3 // 缓存有效期3天，单位毫秒
export const LOGISTICS_REG = /\{([^{]*)\}/gi
